import {
  OnInit,
  Input,
  Component,
  Output,
  ViewChild,
  TemplateRef,
  EventEmitter,
  ChangeDetectorRef
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GlobalNotifierService } from '@app/core/utilities/global-notifier.service';
import { ViewCell } from 'ng2-smart-table';
import { find, filter, merge, findIndex } from 'lodash';
import { Control, SubForma, } from '../../models/formulario-dinamico.model';
import { BaseControl } from '../../dynamic-form';
import { InputTableFormService } from './shared/input-table.form.service';
import { Static } from '@app/shared/util/static';
import { ColumnsTableModalSelect } from '@app/shared/models/modal-select.model';

export interface UpdateData {
  row: any;
  subForm?: SubForma;
  saved: boolean;
}

@Component({
  selector: 'iw-input-table',
  templateUrl: './input-table.component.html',
  styleUrls: ['./input-table.component.scss'],
  providers: [InputTableFormService]
})
export class InputTableComponent implements ViewCell, OnInit {
  // entrada del valor input
  @Input() value: any;
  // entrada de la fila a la cual se le dio click
  @Input() rowData: any;
  // Contiene el label a mostrar en la tabla
  labelCell = '';
  // variable que determina si es un NgSelect
  update = true;
  // Define cuando esta cargando las opciones de los selectores
  loadOptions = false;
  // Define si es una tabla dinamica
  dynamicTable = true;
  // Formulario generado
  form: FormGroup;
  // Contiene los estilos del div de texto
  styleText = {
    height: '24px'
  };
  // Contiene los templetes de los campos personalizados del formulario
  templatesFomr = {};
  // Controles del formulario
  controls: BaseControl<any>[] = [];
  // Datos de la maestra si el tipo de dato es NgSelect
  items: Array<any> = [];
  private aliasLoad = '';
  private indexLoad = -1;
  temporalValue: any;
  // Contiene las columans del selector
  columnsLabel: ColumnsTableModalSelect[] = [];
  private columns: ColumnsTableModalSelect[] = [];
  // Columnas seleccionadas
  selectionsColumns: string[] = [];
  // Contiene la subforma del control
  private _subform: SubForma;
  // Tipo del control
  private _control: Control;
  // Referencia a la plantilla para el control personalizado de ng-select
  @ViewChild('ngSelect') ngSelectTpl: TemplateRef<any>;
  // Referencia a la plantilla para el control personalizado de label
  @ViewChild('label') labelTpl: TemplateRef<any>;
  // Referencia a la plantilla para el botton de coordenadas
  @ViewChild('buttonCordenadas') buttonCordenadasTpl: TemplateRef<any>;
  // salida de loo datos a actualizar
  @Output() dataUpdate: EventEmitter<UpdateData> = new EventEmitter();
  // Indica cuando se necesita refrescar las opciones del control
  loadingOptions: (...arg: any[]) => Promise<Control>;
  runOperations: (...arg: any[]) => Promise<boolean>;

  constructor(
    private itfs: InputTableFormService,
    private cd: ChangeDetectorRef,
  ) { }

  ngOnInit() {
    this.templatesFomr = {
      ngSelectTpl: this.ngSelectTpl,
      labelTpl: this.labelTpl,
      buttonCordenadasTpl: this.buttonCordenadasTpl
    };
    if (this.columnsLabel && this.columnsLabel.length) {
      this.columns = this.getColumns(this.columnsLabel);
    }
    this.loadLabelCell();
    this.update = false;
    if (this.dynamicTable && this.control.alias === this.aliasLoad && this.rowData.index === this.indexLoad) {
      this.loadControl();
    }
  }

  set control(c: Control) {
    this._control = c;
  }

  set subform(c: SubForma) {
    const missingObjects = {
      formulario: c.formulario,
      datos: c.datos,
      configuracion_tabla: c.configuracion_tabla
    };
    this._subform = {} as SubForma;
    Object.keys(c).forEach(key => {
      if (
        key !== 'formulario' &&
        key !== 'configuracion_tabla' &&
        key !== 'datos' &&
        key !== 'controles_generales'
      ) {
        this._subform[key] = Static.copyObjet(c[key]);
      }
    });
    this._subform = merge(this._subform, missingObjects);
    this._subform.campos.forEach(field => {
      field.requerido = true;
    });
  }

  get control(): Control {
    return this._control;
  }

  get subform(): SubForma {
    return this._subform;
  }

  /**
   * Activa el formulario para editar
   *
   * @memberof InputTableComponent
   */
  async updateValue() {
    if (this.dynamicTable && this.control.tipo_campo.nombre === 'ngSelect') {
      this.loadOptions = true;
      this.update = true;
      this.control = await this.loadingOptions(
        this.subform,
        this.control,
        null,
        false,
        false,
        true,
        this.rowData
      ) as Control;
      const indexControlForm = findIndex(this.subform.campos, {id: this.control.id});
      if (indexControlForm !== -1) {
        this.subform.campos[indexControlForm] = this.control;
      }
      this.loadControl();
    } else {
      this.loadControl();
    }
  }

  /**
   * Guardar datos al quitar el focus
   *
   * @param {*} data
   * @memberof InputTableComponent
   */
  onFocusOut(data: any) {
    if (this.dynamicTable) {
      this.update = false;
      this.controls = [];
      let value: any;
      if (this.control.tipo_campo.nombre !== 'number') {
        value = this.form.controls[data].value;
      } else {
        value = Number(Static.numberFormatWithoutThousandsSeparator(
          this.form.controls[data].value,
          this.control.propiedades['separadorMiles'] ? this.control.propiedades['separadorMiles'] : null,
          this.control.propiedades['separadorDecimales'] ? this.control.propiedades['separadorDecimales'] : null
        ));
        this.form.controls[data].setValue(value, {
          onlySelf: false,
          emitEvent: false,
          emitModelToViewChange: true,
          emitViewToModelChange: true
        });
      }
      if (this.form.valid && this.value !== value) {
        const filters = filter(this.subform.campos, el => {
          if (el.validaciones.operaciones.length) {
            const exist = find(el.validaciones.operaciones, opr => {
              if (opr.valores.length) {
                const search = find(
                  opr.valores,
                  val => val.formulario === this.subform.alias && val.campo === this.control.alias
                );
                if (search) {
                  return opr;
                }
              }
            });
            if (exist) {
              return el;
            }
          }
        });
        if (filters && filters.length) {
          filters.forEach(f => {
            delete this.rowData[f.nombre_campo];
          });
        }
        const rowData = Static.copyObjet(this.rowData);
        rowData[data] = value;
        this.dataUpdate.emit({
          row: rowData,
          subForm: this.subform,
          saved: true
        });
      } else {
        this.dataUpdate.emit({
          row: this.rowData,
          subForm: this.subform,
          saved: false
        });
      }
    } else {
      if (this.form.valid && this.value !== this.form.controls[data].value) {
        const rowData = Static.copyObjet(this.rowData);
        rowData[data] = this.form.controls[data].value;
        this.dataUpdate.emit({
          row: rowData,
          saved: true
        });
      }
      this.update = false;
    }
  }

  /**
   * Contener temporalmente la informacion para abrir campo
   *
   * @param {string} alias
   * @param {number} index
   * @param {*} [value]
   * @memberof InputTableComponent
   */
  open(alias: string, index: number, value?: any) {
    this.aliasLoad = alias;
    this.indexLoad = index;
    // this.temporalValue = value;
  }

  private loadLabelCell() {
    if (this.dynamicTable) {
      if (this.control.tipo_campo.nombre === 'ngSelect') {
        this.loadingColumns();
      } else if (this.control.tipo_campo.nombre === 'coordenadas') {
        this.loadingCoordinates();
      } else if (this.control.tipo_campo.nombre === 'date-time-picker') {
        this.loadingDate();
      } else if (this.control.tipo_campo.nombre === 'checkbox') {
        this.loadingCheckbox();
      } else if (this.control.tipo_campo.nombre === 'number') {
        this.loadingNumber();
      } else {
        this.labelCell = this.value;
      }
    } else {
      if (this.controls[0]['type'] === 'checkbox') {
        this.loadingCheckbox();
      } else {
        this.labelCell = this.value;
      }
    }
  }

  /**
   * Crea la cadena con las coordenadas ingresadas
   *
   * @private
   * @memberof InputTableComponent
   */
  private loadingCoordinates() {
    if (this.value['latitud']) {
      this.labelCell += 'latitud: ' + this.value['latitud'];
    }

    if (this.value['longitud']) {
      if (this.labelCell !== '') {
        this.labelCell += ', ';
      }
      this.labelCell += 'Longitud: ' + this.value['longitud'];
    }

    if (this.value['altura']) {
      if (this.labelCell !== '') {
        this.labelCell += ', ';
      }
      this.labelCell += 'Altura: ' + this.value['altura'];
    }
  }

  /**
   * Cargar texto de la fecha
   *
   * @private
   * @memberof InputTableComponent
   */
  private loadingDate() {
    let date: Date;
    let dateS: Date;
    switch (this.control.propiedades.tipo) {
      case 'calendar':
        if (this.value) {
          date = new Date(this.value);
          this.labelCell = date.toLocaleDateString();
        }
        break;
      case 'timer':
        if (this.value) {
          date = new Date(this.value);
          this.labelCell = date.toLocaleTimeString();
        }
        break;
      case 'dateTimer':
        if (this.value) {
          date = new Date(this.value);
          this.labelCell = date.toLocaleDateString() + ' ' + date.toLocaleTimeString();
        }
        break;
      case 'rangeDate':
        if (this.value) {
          date = new Date(this.value[0]);
          dateS = new Date(this.value[1]);
          this.labelCell = date.toLocaleDateString() + ' - ' + dateS.toLocaleDateString();
        }
        break;
      case 'rangeTime':
        if (this.value) {
          date = new Date(this.value[0]);
          dateS = new Date(this.value[1]);
          this.labelCell = date.toLocaleTimeString() + ' - ' + dateS.toLocaleTimeString();
        }
        break;
      default:
        if (this.value) {
          date = new Date(this.value[0]);
          dateS = new Date(this.value[1]);
          this.labelCell = date.toLocaleDateString() + ' ' + date.toLocaleTimeString() +
                            ' - ' + dateS.toLocaleDateString() + ' ' + dateS.toLocaleTimeString();
        }
        break;
    }
  }

  /**
   * Carga el texto de un checkbox
   *
   * @private
   * @memberof InputTableComponent
   */
  private loadingCheckbox() {
    if (this.value) {
      this.labelCell = 'Sí';
    } else if (this.value === false) {
      this.labelCell = 'No';
    } else {
      this.labelCell = '';
    }
  }

  /**
   * Carga el texto de un numero
   *
   * @private
   * @memberof InputTableComponent
   */
  private loadingNumber() {
    if (this.value) {
      if (this.control.propiedades['separadorMiles']) {
        this.labelCell = Static.applyThousandsSeparatorFormat(
          this.value,
          this.control.propiedades['separadorMiles'],
          this.control.propiedades['separadorDecimales']
        );
      } else {
        this.labelCell = this.value;
      }
    }
  }

  /**
   * Cargar label de columna
   *
   * @memberof InputTableComponent
   */
  loadingColumns() {
    if (
      this.columns &&
      this.columns.length &&
      this.columns.length > 1 &&
      this.rowData[this.control.nombre_campo + '_valor']) {
      let labelString = '';
      for (let i = 0; i < this.selectionsColumns.length; i++) {
        const configColum = find(this.columns, {key: this.selectionsColumns[i]});
        const indexConfigColum = findIndex(this.columns, {key: this.selectionsColumns[i]});
        if (configColum) {
          const labels = configColum.label.split(' - ');
          let label = '';
          if (labels.length > 1) {
            label = labels[1];
          } else {
            label = labels[0];
          }
          let element = '<strong>' + label + ': </strong>';
          if (typeof this.rowData[this.control.nombre_campo + '_valor'] === 'object') {
            if (
              configColum.type !== 'ngSelect' ||
              (
                this.rowData[this.control.nombre_campo + '_valor'].hasOwnProperty(configColum.key) &&
                typeof this.rowData[this.control.nombre_campo + '_valor'][configColum.key] !== 'object'
              )
            ) {
              if (this.rowData[this.control.nombre_campo + '_valor'][configColum.key]) {
                element += this.rowData[this.control.nombre_campo + '_valor'][configColum.key] + ' ';
              } else {
                element += 'No aplica ';
              }
            } else {
              const columns = String(configColum.key).split('-');
              if (columns.length && columns.length > 1) {
                let textColumn = '';
                columns.forEach((c, ix) => {
                  if (ix > 0) {
                    textColumn += c;
                    if (ix < (columns.length - 1)) {
                      textColumn += '-';
                    }
                  }
                });
                if (this.rowData[this.control.nombre_campo + '_valor'][columns[0]][textColumn]) {
                  element += this.rowData[this.control.nombre_campo + '_valor'][columns[0]][textColumn] + ' ';
                } else {
                  element += 'No aplica ';
                }
              } else {
                element += 'No aplica ';
              }
            }
          } else {
            const valueColumns = String(this.rowData[this.control.nombre_campo + '_valor']).split('/');
            if (valueColumns.length && indexConfigColum < valueColumns.length) {
              element += valueColumns[indexConfigColum];
            } else {
              element += 'No aplica ';
            }
          }
          if (i > 0) {
            labelString += '/ ' + element;
          } else {
            labelString = element;
          }
        } else {
          if (i > 0) {
            labelString += '/ <strong>Columna</strong> No aplica';
          } else {
            labelString = '<strong>Columna</strong> No aplica';
          }
        }
      }
      const parser = new DOMParser();
      this.labelCell = parser.parseFromString(labelString, 'text/html').body.innerHTML;
    } else {
      if (
        this.rowData &&
        this.rowData.hasOwnProperty(this.control.nombre_campo + '_valor')
      ) {
        if (
          this.rowData[this.control.nombre_campo + '_valor'] &&
          typeof this.rowData[this.control.nombre_campo + '_valor'] === 'object' &&
          this.rowData[this.control.nombre_campo + '_valor'].hasOwnProperty(this.selectionsColumns[0])
        ) {
          this.labelCell = this.rowData[this.control.nombre_campo + '_valor'][this.selectionsColumns[0]];
        } else {
          this.labelCell = this.rowData[this.control.nombre_campo + '_valor'];
        }
      } else {
        this.labelCell = '';
      }
    }
  }

  /**
   * Retorna todas las columnas incluyendo las columnas dependientes en un mismo nivel
   *
   * @param {ColumnsTableModalSelect[]} c
   * @returns {ColumnsTableModalSelect[]}
   * @memberof InputTableComponent
   */
  getColumns(c: ColumnsTableModalSelect[]): ColumnsTableModalSelect[] {
    const cols: ColumnsTableModalSelect[] = [];
    c.forEach(column => {
      if (!column.columnsDependence || !column.columnsDependence.length) {
        cols.push(column);
      } else {
        const cs = this.getColumns(column.columnsDependence);
        if (cs.length) {
          cs.forEach(cl => {
            cols.push(cl);
          });
        }
      }
    });
    return cols;
  }

  /**
   * Carga el control para editar
   *
   * @private
   * @memberof InputTableComponent
   */
  private async loadControl(ctrl?: any) {
    if (this.dynamicTable) {
      this.runOperations(
        this.subform,
        this.control,
        this.rowData
      ).then(_r => {
        const temp = {
          form: this.subform,
          control: this.control
        };
        this.controls = [];
        this.controls.push(
          this.itfs.getControl(
            ctrl ? ctrl : this.control,
            this.templatesFomr,
            this.temporalValue ? this.temporalValue : this.value,
            key => this.onFocusOut(key),
            temp
          )
        );
        this.update = true;
        this.cd.detectChanges();
        if (!this.form.controls[this.control.nombre_campo].disabled) {
          setTimeout(() => {
            let el: any;
            if (this.control.tipo_campo.nombre === 'ngSelect') {
              el = document.querySelector('#' + this.control.nombre_campo + '_table div div div input');
            } else {
              el = document.querySelector('#' + this.control.nombre_campo + '_table');
            }
            if (el instanceof HTMLElement) {
              el.focus();
            }
          });
        } else {
          this.update = false;
          this.cd.detectChanges();
        }
      }).catch(_error => {
        this.update = false;
        console.log(_error);
      });
    } else {
      this.controls[0].value = this.value;
      this.controls[0].onFocusOut = key => this.onFocusOut(key);
      this.update = true;
      setTimeout(() => {
        let el: any;
        el = document.querySelector('#' + this.controls[0].key);
        if (el instanceof HTMLElement) {
          el.focus();
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/component-table/input-table/input-table.component.ts